const QueueRecordCount = () => import('@common/QueueRecordCount/QueueRecordCount');
const RegisterReportingPoint = () => import('@common/RegisterReportingPoint/RegisterReportingPoint');
const TableDataManagement = () => import('@common/TableDataManagement/TableDataManagement');
const Widget = () => import('@common/Widget/Widget');
const WidgetMaster = () => import('@common/WidgetMaster/WidgetMaster');
const DicMsgManagement = () => import('@common/DicMsgManagement/DicMsgManagement');
const Notification = () => import('@common/Notification/Notification');
const UserManagement = () => import('@common/UserManagement/UserManagement');
const UserGroupManagement = () => import('@common/UserGroupManagement/UserGroupManagement');
const ProgramRegistration = () => import('@common/ProgramRegistration/ProgramRegistration');
const ProcessRegistration = () => import('@common/ProcessRegistration/ProcessRegistration');
const MappingProgramProcess = () => import('@common/MappingProgramProcess/MappingProgramProcess');
const LoginHistory = () => import('@common/LoginHistory/LoginHistory');
const UserGroupMap = () => import('@common/UserGroupMap/UserGroupMap');
const UserAccess = () => import('@common/UserAccess/UserAccess');
const ScreenUsage = () => import('@common/ScreenUsage/ScreenUsage');
const MenuManagement = () => import('@common/MenuManagement/MenuManagement');
const SyncManagement = () => import('@common/SyncManagement/SyncManagement');
const ErrorLog = () => import('@common/ErrorLog/ErrorLog');
const CommonCode = () => import('@common/CommonCode/CommonCode');
const UserGroupControlManagement = () => import('@common/UserGroupControlManagement/UserGroupControlManagement');
const LibraryDependency = () => import('@common/LibraryDependency/LibraryDependency');
const ControlManagement = () => import('@common/ControlManagement/ControlManagement');
const GuideBoard = () => import('@common/GuideBoard/GuideBoard');
const SQLEditor = () => import('@common/SQLEditor/SQLEditor');

export default {
	// TaskManagement,
	QueueRecordCount,
	RegisterReportingPoint,
	TableDataManagement,
	Widget,
	WidgetMaster,
	DicMsgManagement,
	Notification,
	UserManagement,
	UserGroupManagement,
	ProgramRegistration,
	ProcessRegistration,
	MappingProgramProcess,
	LoginHistory,
	UserGroupMap,
	UserAccess,
	ScreenUsage,
	MenuManagement,
	SyncManagement,
	ErrorLog,
	CommonCode,
	UserGroupControlManagement,
	LibraryDependency,
	ControlManagement,
	// DaemonProcessManagement,
	GuideBoard,
	SQLEditor
};

export {
	// TaskManagement,
	QueueRecordCount,
	RegisterReportingPoint,
	TableDataManagement,
	Widget,
	WidgetMaster,
	DicMsgManagement,
	Notification,
	UserManagement,
	UserGroupManagement,
	ProgramRegistration,
	ProcessRegistration,
	MappingProgramProcess,
	LoginHistory,
	UserGroupMap,
	UserAccess,
	ScreenUsage,
	MenuManagement,
	SyncManagement,
	ErrorLog,
	CommonCode,
	UserGroupControlManagement,
	LibraryDependency,
	ControlManagement,
	// DaemonProcessManagement,
	GuideBoard,
	SQLEditor
};
